import React, { useContext } from 'react';
import classes from './ServiceBlock.module.css';
import { ThemeContext } from '../../../App';

interface IServiceBlockProps {
  image: string;
  text: string;
}

export default function ServiceBlock(props: IServiceBlockProps) {
  const { theme } = useContext(ThemeContext);

  return (
    <div
      id={classes[theme]}
      className={
        classes.block + ' flex flex-col items-center w-1/2 md:w-1/3 lg:w-vw14'
      }
    >
      <img src={props.image} />
      <p className="text-center xs:text-xsAddTxt sm:text-smAdd2Txt md:text-mdAddTxt lg:text-lg2AddTxt md:pb-vh10-bottom">
        {props.text}
      </p>
    </div>
  );
}
